import React, { useState } from "react";
import { motion } from "framer-motion";
import api from "@/lib/api";

const MOTIVOS = [
  { key: "no_salio", label: "No me terminó de salir" },
  { key: "a_mano", label: "Me sale más rápido a mano" },
  { key: "cambio", label: "Cambió cómo trabajamos" },
  { key: "otra", label: "Otra cosa" },
];

// Chequeo de vida: a los 14 y 30 días de poner un proceso andando, preguntamos si lo sigue usando.
export default function ChequeoVida({ chequeo, onListo }) {
  const [paso, setPaso] = useState("pregunta"); // pregunta | motivo | listo
  const [motivo, setMotivo] = useState(null);
  const [texto, setTexto] = useState("");
  const [enviando, setEnviando] = useState(false);

  const enviar = async (valor, motivoFinal, motivoTexto) => {
    setEnviando(true);
    try {
      await api.post("/chequeo-vida", {
        proceso_id: chequeo.proceso_id,
        dia: chequeo.dia,
        valor,
        motivo: motivoFinal || null,
        motivo_texto: motivoTexto || "",
      });
    } catch {}
    onListo && onListo();
  };

  const btnBase = "font-sans rounded-full px-6 py-2.5 transition-colors";

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      className="rounded-xl p-6 mb-10"
      style={{ background: "#0F0F0F", border: "1px solid rgba(201,168,76,0.35)" }}
      data-testid="chequeo-vida"
    >
      {paso === "pregunta" && (
        <>
          <div className="mono-label text-dorado mb-3" style={{ fontSize: 10 }}>
            UN MINUTO · CÓMO VA {chequeo.dia === 30 ? "AL MES" : "A LAS DOS SEMANAS"}
          </div>
          <p className="font-serif" style={{ fontSize: 23, color: "#EDEDED", lineHeight: 1.35 }} data-testid="chequeo-vida-pregunta">
            ¿Seguís usando la IA para <span style={{ color: "#C9A84C" }}>{chequeo.nombre}</span>?
          </p>
          <div className="flex flex-wrap gap-3 mt-5">
            <button
              onClick={() => enviar("si")}
              disabled={enviando}
              className={btnBase}
              style={{ background: "#C9A84C", color: "#0A0A0A", fontSize: 14, fontWeight: 600 }}
              data-testid="chequeo-vida-si"
            >
              Sí, todos los días
            </button>
            <button
              onClick={() => enviar("a_veces")}
              disabled={enviando}
              className={btnBase}
              style={{ background: "transparent", border: "1px solid #3C3C3C", color: "#D8D8D8", fontSize: 14 }}
              data-testid="chequeo-vida-aveces"
            >
              A veces
            </button>
            <button
              onClick={() => setPaso("motivo")}
              disabled={enviando}
              className={btnBase}
              style={{ background: "transparent", border: "1px solid #3C3C3C", color: "#B9B9B9", fontSize: 14 }}
              data-testid="chequeo-vida-lodeje"
            >
              Lo dejé
            </button>
          </div>
        </>
      )}

      {paso === "motivo" && (
        <>
          <p className="font-serif" style={{ fontSize: 22, color: "#EDEDED", lineHeight: 1.35 }}>
            Sin problema. ¿Qué pasó?
          </p>
          <div className="flex flex-col gap-2.5 mt-4">
            {MOTIVOS.map((m) => (
              <button
                key={m.key}
                onClick={() => setMotivo(m.key)}
                className="font-sans text-left rounded-lg px-4 py-2.5 transition-colors"
                style={{
                  border: motivo === m.key ? "1px solid #C9A84C" : "1px solid #2A2A2A",
                  background: motivo === m.key ? "rgba(201,168,76,0.08)" : "transparent",
                  color: "#D8D8D8",
                  fontSize: 14,
                }}
                data-testid={`chequeo-vida-motivo-${m.key}`}
              >
                {m.label}
              </button>
            ))}
          </div>
          <textarea
            value={texto}
            onChange={(e) => setTexto(e.target.value)}
            placeholder="Si querés, contame un poco más (opcional)."
            rows={2}
            className="w-full mt-4 rounded-lg font-sans px-3 py-2.5"
            style={{ background: "#0A0A0A", border: "1px solid #2A2A2A", color: "#E8E8E8", fontSize: 14, resize: "none" }}
            data-testid="chequeo-vida-motivo-texto"
          />
          <div className="flex gap-3 mt-4">
            <button
              onClick={() => enviar("lo_deje", motivo, texto)}
              disabled={enviando || !motivo}
              className={btnBase}
              style={{
                background: motivo ? "#C9A84C" : "#2A2A2A",
                color: motivo ? "#0A0A0A" : "#6B6B6B",
                fontSize: 14,
                fontWeight: 600,
              }}
              data-testid="chequeo-vida-motivo-enviar"
            >
              Listo
            </button>
          </div>
        </>
      )}
    </motion.div>
  );
}
